import React from 'react';

import Projects from '../../components/projects';

// import './index.css';

const Component = () => {
    return (
        <div className="publications">
            <h3>Projects</h3>
            <Projects />
        </div>
    );
};

export default Component;
